export enum ViolationSeverity {
  INFO = 'INFO',
  WARNING = 'WARNING',
  CRITICAL = 'CRITICAL'
}

export enum ProctoringViolationType {
  NO_FACE = 'NO_FACE',
  MULTIPLE_FACES = 'MULTIPLE_FACES',
  LOOKING_AWAY = 'LOOKING_AWAY',
  FACE_TOO_FAR = 'FACE_TOO_FAR',
  TAB_SWITCH = 'TAB_SWITCH',
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  SESSION_START = 'SESSION_START',
  SESSION_END = 'SESSION_END',
  CAMERA_TURNED_OFF = 'CAMERA_TURNED_OFF',
  EYES_CLOSED = 'EYES_CLOSED',
  BACKGROUND_VOICE = 'BACKGROUND_VOICE'
}

export enum TerminationReason {
  MAX_WARNINGS_EXCEEDED = 'MAX_WARNINGS_EXCEEDED',
  CRITICAL_VIOLATION = 'CRITICAL_VIOLATION',
  TAB_SWITCH_TIMEOUT = 'TAB_SWITCH_TIMEOUT',
  CAMERA_TURNED_OFF = 'CAMERA_TURNED_OFF'
}

export interface ProctoringEvent {
  eventId: string;
  timestamp: string;
  type: ProctoringViolationType;
  severity: ViolationSeverity;
  metadata?: any;
}

export interface ProctoringRule {
  type: string;
  severity: ViolationSeverity;
  debounce_seconds: number;
  action: string;
}

export interface ProctoringConfig {
  id: string;
  total_allowed_violation_count: number;
  rules: ProctoringRule[];
  modelsPath?: string;
}

export interface ProctoringReport {
  sessionId: string;
  candidateId: string;
  overallStatus: 'PASSED' | 'FLAGGED' | 'TERMINATED';
  criticalViolationsCount: number;
  warningViolationsCount: number;
  events: ProctoringEvent[];
}
